module.exports = __webpack_public_path__ + "CC.png?9b5f975ab448dd98478406afe39c7ca6";